import type { RenterAccountInfoInterface } from './Types';

const AccountInfoModel = (account: RenterAccountInfoInterface) => {
  const { accountLast4 = '', accountName = '', accountType = '', createdThrough = '' } = account || {};

  return {
    accountLast4: accountLast4 && String(accountLast4),
    accountName,
    accountType,
    createdThrough,
  };
};

export default AccountInfoModel;
